import { FC } from "react"
import { EmailsTable } from "src/components/pages/emails-data/ui/EmailsTable"

export const EmailsTab: FC = () => {
  return <EmailsTable />
}
